import { CompanySchema } from "./company";
import { DocumentSchema } from "@/services/api";
import * as z from "zod";

export type Nullable<T> = T | null;

export const ActionTypeSchema = z.object({
  Id: z.number(),
  ActionNameAr: z.string(),
  ActionNameEn: z.string(),
});

export const ApplicationSchema = z.object({
  Id: z.number(),
  ApplicationNameAr: z.string(),
  ApplicationNameEn: z.string(),
  ApplicationDomainId: z.number(),
  Visible: z.boolean(),
  ActionType: ActionTypeSchema,
  Company: CompanySchema,
  RequiredDocuments: z.array(DocumentSchema),
  Value: z.string(),
});

export type ActionType = z.infer<typeof ActionTypeSchema>;
export type Application = z.infer<typeof ApplicationSchema>;

export type ApplicationResponse = Application[];

export interface ApplicationPayload {
  ReferenceNumber: string | null;
  CompanyId: number;
  NoOfPersons: number;
  NoOfVehicles: number;
  NoOfCameras: number;
  NoOfVessels: number;
  HasPersons: boolean;
  From: string | Date;
  To: string | Date;
  ContractorId: number;
  SubContractorId?: number;
}
